import { render, staticRenderFns } from "./brokerpsp.vue?vue&type=template&id=81bcbbe2"
import script from "./brokerpsp.vue?vue&type=script&lang=js"
export * from "./brokerpsp.vue?vue&type=script&lang=js"
import style0 from "./brokerpsp.vue?vue&type=style&index=0&id=81bcbbe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports